import { render, staticRenderFns } from "./PlayPauseIcon.vue?vue&type=template&id=36f7d529&scoped=true&"
import script from "./PlayPauseIcon.vue?vue&type=script&lang=js&"
export * from "./PlayPauseIcon.vue?vue&type=script&lang=js&"
import style0 from "./PlayPauseIcon.vue?vue&type=style&index=0&id=36f7d529&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f7d529",
  null
  
)

export default component.exports